import { combineReducers } from "redux";
import {
  DEFAULT_STATE,
  DEFAULT_STATE_FF_EF,
  sidebarToggleItems,
} from "../utility/constants";
import moment from "moment";
import {
  confirmSelectedCab,
  getFareEstimates,
  getSelectedCab,
} from "../containers/bookingsNew/Actions";

const createReducer = (reducerName, defaultStateParam) => {
  const defaultState = defaultStateParam || DEFAULT_STATE;
  return (state = defaultState, action) => {
    switch (action.type) {
      case `${reducerName}_PENDING`:
      case `${reducerName}_FULFILLED`:
      case `${reducerName}_REJECTED`:
        return Object.assign({}, action.payload);
      default:
        return state;
    }
  };
};

const createStaticReducer = (reducerName, defaultStateParam) => {
  const defaultState = defaultStateParam || DEFAULT_STATE;
  return (state = defaultState, action) => {
    switch (action.type) {
      case `${reducerName}`:
        return Object.assign({}, action.payload);
      default:
        return state;
    }
  };
};

const rootReducer = combineReducers({
  sidebar: createStaticReducer("TOGGLE_SIDEBAR", {
    visible: true,
  }),
  updateShouldCallSaveApi: createReducer("UPDATE_SHOULD_CALL_SAVE_API", {
    shouldCallSaveApi: true,
  }),
  sidebarMenuToggle: createStaticReducer(
    "TOGGLE_SIDEBAR_MENU",
    sidebarToggleItems,
  ),
  notificationbar: createStaticReducer("TOGGLE_NOTIFICATIONBAR", {
    visible: true,
  }),
  login: createReducer("LOGIN", DEFAULT_STATE_FF_EF),
  forgotpassword: createReducer("FORGOT_PASSWORD", DEFAULT_STATE_FF_EF),
  changepassword: createReducer("CHANGE_PASSWORD", DEFAULT_STATE_FF_EF),
  logout: createReducer("LOGOUT", {
    logout: false,
  }),

  distanceFares: createReducer("GET_DISTANCE_FARE", DEFAULT_STATE_FF_EF),
  distanceFareAdd: createReducer("DISTANCE_FARE_ADD", DEFAULT_STATE_FF_EF),

  vehicleTypes: createReducer("GET_VEHICLE_TYPES", DEFAULT_STATE_FF_EF),
  allVehicleTypes: createReducer("GET_ALL_VEHICLE_TYPES", DEFAULT_STATE_FF_EF),

  pricingStatus: createReducer("PRICING_STATUS_UPDATE", DEFAULT_STATE_FF_EF),
  pricingDelete: createReducer("PRICING_DELETE", DEFAULT_STATE_FF_EF),

  timeFares: createReducer("GET_TIME_FARE", DEFAULT_STATE_FF_EF),
  timeFareAdd: createReducer("TIME_FARE_ADD", DEFAULT_STATE_FF_EF),

  calendarFares: createReducer("GET_CALENDAR_FARE", DEFAULT_STATE_FF_EF),
  calendarFareAdd: createReducer("CALENDAR_FARE_ADD", DEFAULT_STATE_FF_EF),

  geofenceFares: createReducer("GET_GEOFENCE_FARE", DEFAULT_STATE_FF_EF),
  geofenceFareAdd: createReducer("GEOFENCE_FARE_ADD", DEFAULT_STATE_FF_EF),

  fixedFares: createReducer("GET_FIXED_FARE", DEFAULT_STATE_FF_EF),
  fixedFareAdd: createReducer("FIXED_FARE_ADD", DEFAULT_STATE_FF_EF),

  locations: createReducer("GET_LOCATIONS", DEFAULT_STATE_FF_EF),
  locationAdd: createReducer("LOCATION_ADD", DEFAULT_STATE_FF_EF),

  routeBasedFares: createReducer("GET_ROUTE_BASED_FARE", DEFAULT_STATE_FF_EF),
  routeBasedFareAdd: createReducer("ROUTE_BASED_FARE_ADD", DEFAULT_STATE_FF_EF),

  operatingAreas: createReducer("GET_OPERATING_AREA", DEFAULT_STATE_FF_EF),
  operatingAreaAdd: createReducer("OPERATING_AREA_ADD", DEFAULT_STATE_FF_EF),
  operatingAreaDelete: createReducer(
    "OPERATING_AREA_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  OperatorAreas: createReducer("OPERATOR_OPERATING_AREA", DEFAULT_STATE_FF_EF),
  OperatorAreaAdd: createReducer(
    "OPERATOR_OPERATING_AREA_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  OperatorAreaDelete: createReducer(
    "OPERATOR_OPERATING_AREA_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  otaGeofence: createReducer("OTA_GEOFENCE", DEFAULT_STATE_FF_EF),
  otaGeofenceDetail: createReducer("OTA_GEOFENCE_DETAILS", DEFAULT_STATE_FF_EF),
  otaGeofenceAdd: createReducer("OTA_GEOFENCE_ADD", DEFAULT_STATE_FF_EF),
  otaGeofenceById: createReducer("OTA_GEOFENCE_BY_ID", DEFAULT_STATE_FF_EF),

  airportPricing: createReducer("GET_AIRPORT_PRICING", DEFAULT_STATE_FF_EF),
  airportPricingAdd: createReducer("AIRPORT_PRICING_ADD", DEFAULT_STATE_FF_EF),
  airportPricingById: createReducer(
    "AIRPORT_PRICING_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  airportPricingDelete: createReducer(
    "AIRPORT_PRICING_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  otherPricing: createReducer("GET_OTHER_PRICING", DEFAULT_STATE_FF_EF),
  otherPricingAdd: createReducer("OTHER_PRICING_ADD", DEFAULT_STATE_FF_EF),

  surgePricing: createReducer("GET_SURGE_PRICING", DEFAULT_STATE_FF_EF),
  surgePricingAdd: createReducer("SURGE_PRICING_ADD", DEFAULT_STATE_FF_EF),
  surgePricingById: createReducer("SURGE_PRICING_BY_ID", DEFAULT_STATE_FF_EF),
  surgePricingDelete: createReducer(
    "SURGE_PRICING_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  unitSlabPricing: createReducer("GET_UNIT_SLAB_PRICING", DEFAULT_STATE_FF_EF),
  unitSlabPricingAdd: createReducer(
    "UNIT_SLAB_PRICING_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  unitSlabPricingById: createReducer(
    "UNIT_SLAB_PRICING_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  unitSlabPricingDelete: createReducer(
    "UNIT_SLAB_PRICING_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  bookingsAdd: createReducer("BOOKINGS_ADD", DEFAULT_STATE_FF_EF),
  bookingsById: createReducer("BOOKINGS_BY_ID", DEFAULT_STATE_FF_EF),
  auctoBookingsById: createReducer("AUCTO_BOOKINGS_BY_ID", DEFAULT_STATE_FF_EF),

  vehicleTypeAdd: createReducer("VEHICLE_TYPE_ADD", DEFAULT_STATE_FF_EF),
  vehicleTypeStatus: createReducer("VEHICLE_TYPE_STATUS", DEFAULT_STATE_FF_EF),
  vehicleTypeDelete: createReducer("VEHICLE_TYPE_DELETE", DEFAULT_STATE_FF_EF),

  taxidaQuotes: createReducer("GET_TAXIDA_QUOTES", DEFAULT_STATE_FF_EF),
  taxidaQuoteAdd: createReducer("TAXIDA_QUOTE_ADD", DEFAULT_STATE_FF_EF),
  taxidaQuoteStatus: createReducer("TAXIDA_QUOTE_STATUS", DEFAULT_STATE_FF_EF),
  taxidaQuoteDelete: createReducer("TAXIDA_QUOTE_DELETE", DEFAULT_STATE_FF_EF),

  commissions: createReducer("GET_COMMISSIONS", DEFAULT_STATE_FF_EF),
  commissionAdd: createReducer("ADD_COMMISSION", DEFAULT_STATE_FF_EF),
  commissionDelete: createReducer("COMMISSION_DELETE", DEFAULT_STATE_FF_EF),
  commissionsDD: createReducer("GET_COMMISSIONSDD", DEFAULT_STATE_FF_EF),

  bidDriver: createReducer("GET_BIDDRIVER", DEFAULT_STATE_FF_EF),
  assignDriver: createReducer("GET_ASSIGNDRIVER", DEFAULT_STATE_FF_EF),
  customerList: createReducer("GET_CUSTOMERLIST", DEFAULT_STATE_FF_EF),
  customerBookingHistory: createReducer(
    "GET_CUSTOMER_BOOKING_HISTORY",
    DEFAULT_STATE_FF_EF,
  ),

  assignOperator: createReducer("GET_ASSIGN_OPERATOR", DEFAULT_STATE_FF_EF),
  bidOperator: createReducer("GET_BID_OPERATOR", DEFAULT_STATE_FF_EF),
  bidOperatorGroup: createReducer(
    "GET_BID_OPERATOR_GROUP",
    DEFAULT_STATE_FF_EF,
  ),

  driver: createReducer("GET_DRIVER", DEFAULT_STATE_FF_EF),
  driverDelete: createReducer("DRIVER_DELETE", DEFAULT_STATE_FF_EF),
  driverAdd: createReducer("DRIVER_ADD", DEFAULT_STATE_FF_EF),
  driverById: createReducer("DRIVER_BY_ID", DEFAULT_STATE_FF_EF),

  corporateDriver: createReducer("GET_CORPORATE_DRIVER", DEFAULT_STATE_FF_EF),
  corporateDriverDelete: createReducer(
    "CORPORATE_DRIVER_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  corporateDriverAdd: createReducer(
    "CORPORATE_DRIVER_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  corporateDriverById: createReducer(
    "CORPORATE_DRIVER_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  corpDrivers: createReducer("FETCH_CORPORATE_DRIVER", DEFAULT_STATE_FF_EF),

  vehicleTypeData: createReducer("VEHICLE_TYPE_FOR_SD", DEFAULT_STATE_FF_EF),
  specialDay: createReducer("GET_SPECIALDAY", DEFAULT_STATE_FF_EF),
  specialDayDelete: createReducer("SPECIALDAY_DELETE", DEFAULT_STATE_FF_EF),
  specialDayAdd: createReducer("SPECIALDAY_ADD", DEFAULT_STATE_FF_EF),

  adminSpecialDay: createReducer("GET_ADMIN_SPECIALDAY", DEFAULT_STATE_FF_EF),
  adminSpecialDayDelete: createReducer(
    "ADMIN_SPECIALDAY_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  adminSpecialDayAdd: createReducer(
    "ADMIN_SPECIALDAY_ADD",
    DEFAULT_STATE_FF_EF,
  ),

  specialDayException: createReducer(
    "SPECIALDAY_EXCEPTION",
    DEFAULT_STATE_FF_EF,
  ),

  businessUser: createReducer("GET_BUSINESS_USER", DEFAULT_STATE_FF_EF),
  businessUserAdd: createReducer("BUSINESS_USER_ADD", DEFAULT_STATE_FF_EF),
  businessUserById: createReducer("BUSINESS_USER_BY_ID", DEFAULT_STATE_FF_EF),

  customers: createReducer("GET_CUSTOMERS", DEFAULT_STATE_FF_EF),
  customerUpdate: createReducer("CUSTOMER_UPDATE", DEFAULT_STATE_FF_EF),

  driverGroup: createReducer("GET_DRIVER_GROUP", DEFAULT_STATE_FF_EF),
  driverGroupDelete: createReducer("DRIVER_GROUP_DELETE", DEFAULT_STATE_FF_EF),

  driverList: createReducer("GET_DRIVERLIST", DEFAULT_STATE_FF_EF),
  driverListAdd: createReducer("DRIVERLIST_ADD", DEFAULT_STATE_FF_EF),
  driverListById: createReducer("DRIVERLIST_BY_ID", DEFAULT_STATE_FF_EF),

  admins: createReducer("GET_ADMINS", DEFAULT_STATE_FF_EF),
  adminAdd: createReducer("ADMIN_ADD", DEFAULT_STATE_FF_EF),
  adminDelete: createReducer("ADMIN_DELETE", DEFAULT_STATE_FF_EF),

  controllers: createReducer("GET_CONTROLLERS", DEFAULT_STATE_FF_EF),
  controllerAdd: createReducer("CONTROLLER_ADD", DEFAULT_STATE_FF_EF),
  controllerDelete: createReducer("CONTROLLER_DELETE", DEFAULT_STATE_FF_EF),

  tripList: createReducer("GET_TRIPLIST", DEFAULT_STATE_FF_EF),
  requestedTrips: createReducer("GET_REQUEST_TRIPS", DEFAULT_STATE_FF_EF),
  favouriteTrips: createReducer("GET_FAVOURITE_TRIPS", DEFAULT_STATE_FF_EF),
    refexLogs: createReducer("GET_REFEX_LOGS", DEFAULT_STATE_FF_EF),

  taxidaTrips: createReducer("GET_TAXIDA_TRIPS", DEFAULT_STATE_FF_EF),
  queuedTrips: createReducer("GET_QUEUED_TRIPS", DEFAULT_STATE_FF_EF),

  auctoTripList: createReducer("GET_AUCTO_TRIPLIST", DEFAULT_STATE_FF_EF),
  acceptedTripsFilters: createStaticReducer("ACCEPTED_TRIPS_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),

  tripListDetail: createReducer("GET_TRIP_DETAILS", DEFAULT_STATE_FF_EF),
  tripFareDetail: createReducer("GET_FARE_DETAILS", DEFAULT_STATE_FF_EF),
  enquiryListDetail: createReducer("GET_ENQUIRY_DETAILS", DEFAULT_STATE_FF_EF),
  updateTripListDetail: createReducer(
    "UPDATE_TRIP_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  operatorAssign: createReducer("UPDATE_OPERATOR_ASSIGN", DEFAULT_STATE_FF_EF),

  aggregatorDriverAssign: createReducer(
    "AGGREGATOR_DRIVER_ASSIGN",
    DEFAULT_STATE_FF_EF,
  ),

  aggregatorStatusChange: createReducer(
    "AGGREGATOR_STATUS_CHANGE",
    DEFAULT_STATE_FF_EF,
  ),

  getDeviceID: createReducer("GET_DEVICE_ID", DEFAULT_STATE_FF_EF),

  etsTripListDetail: createReducer("GET_ETS_TRIP_DETAILS", DEFAULT_STATE_FF_EF),
  updateBookingInfoDetail: createReducer(
    "UPDATE_BOOKING_INFO_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  updateEmployeeInfoDetail: createReducer(
    "UPDATE_EMPLOYEE_INFO_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),

  paymentOptions: createReducer("GET_PAYMENT_OPTIONS", DEFAULT_STATE_FF_EF),
  updatePaymentOptions: createReducer(
    "UPDATE_PAYMENT_OPTIONS",
    DEFAULT_STATE_FF_EF,
  ),

  updateBookingsStatus: createReducer(
    "UPDATE_TRIP_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  updateStatus: createReducer("UPDATE_STATUS", DEFAULT_STATE_FF_EF),

  operatorBids: createReducer("GET_OPERATOR_BIDS", DEFAULT_STATE_FF_EF),

  acceptedTrips: createReducer("GET_ACCEPTED_TRIPS", DEFAULT_STATE_FF_EF),
  auctoTripListFilters: createStaticReducer("AUCTO_TRIPS_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  customerDetailsById: createReducer(
    "CUSTOMER_DETAILS_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  viewOperatorBidlist: createReducer(
    "VIEW_OPERATOR_BIDLIST_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  viewAuctoBidlist: createReducer(
    "VIEW_AUCTO_BIDLIST_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  upcomingTrips: createReducer("GET_UPCOMING_TRIPS", DEFAULT_STATE_FF_EF),
  bids: createReducer("GET_BIDS", DEFAULT_STATE_FF_EF),
  jobInHandCount: createReducer("JOBINHAND_COUNT", DEFAULT_STATE_FF_EF),

  operatorStatements: createReducer("GET_STATEMENTS", DEFAULT_STATE_FF_EF),
  tripStatus: createReducer("GET_TRIPSTATUS", DEFAULT_STATE_FF_EF),
  operatorInvoiceById: createReducer(
    "OPERATOR_INVOICE_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  driverAlerts: createReducer("GET_DRIVER_ALERTS", DEFAULT_STATE_FF_EF),
  driverAlertUpdate: createReducer("DRIVER_ALERTS_UPDATE", DEFAULT_STATE_FF_EF),
  driverAlertDelete: createReducer("DRIVER_ALERTS_DELETE", DEFAULT_STATE_FF_EF),

  countries: createReducer("GET_COUNTRIES", DEFAULT_STATE_FF_EF),
  districts: createReducer("GET_DISTRICTS", DEFAULT_STATE_FF_EF),

  tripListFilters: createStaticReducer("TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  requestTripListFilters: createStaticReducer("REQUEST_TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: moment().format("DD-MM-YYYY"),
  }),
  queuedTripListFilters: createStaticReducer("QUEUED_TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  taxidaTripListFilters: createStaticReducer("TAXIDA_TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  currentTab: createStaticReducer("CURRENT_TAB", {
    currentTab: "Accepted trips",
  }),

  promoCodes: createReducer("GET_PROMOCODES", DEFAULT_STATE_FF_EF),
  promoCodeAdd: createReducer("ADD_PROMOCODE", DEFAULT_STATE_FF_EF),
  promoCodeDelete: createReducer("PROMOCODE_DELETE", DEFAULT_STATE_FF_EF),
  promoCodeById: createReducer("PROMOCODE_BY_ID", DEFAULT_STATE_FF_EF),

  operators: createReducer("GET_OPERATORS", DEFAULT_STATE_FF_EF),
  operatorAdd: createReducer("OPERATOR_ADD", DEFAULT_STATE_FF_EF),
  operatorDelete: createReducer("OPERATOR_DELETE", DEFAULT_STATE_FF_EF),
  operatorsDD: createReducer("GET_OPERATORSDD", DEFAULT_STATE_FF_EF),
  operatorById: createReducer("OPERATOR_BY_ID", DEFAULT_STATE_FF_EF),
  operatorDriver: createReducer("GET_OPERATOR_DRIVER", DEFAULT_STATE_FF_EF),
  operatorGroups: createReducer("GET_OPERATOR_GROUPS", DEFAULT_STATE_FF_EF),
  operatorGroupDelete: createReducer(
    "OPERATOR_GROUP_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  operatorList: createReducer("GET_OPERATORLIST", DEFAULT_STATE_FF_EF),
  operatorListAdd: createReducer("OPERATORLIST_ADD", DEFAULT_STATE_FF_EF),
  operatorListById: createReducer("OPERATORLIST_BY_ID", DEFAULT_STATE_FF_EF),

  operatorPricingAdd: createReducer(
    "OPERATOR_PRICING_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  operatorPricingById: createReducer(
    "OPERATOR_PRICING_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  vehicleList: createReducer("GET_VEHICLE_LIST", DEFAULT_STATE_FF_EF),
  vehicleAdd: createReducer("ADD_VEHICLE", DEFAULT_STATE_FF_EF),
  vehicleListDelete: createReducer("VEHICLE_LIST_DELETE", DEFAULT_STATE_FF_EF),
  vehicleById: createReducer("VEHICLE_BY_ID", DEFAULT_STATE_FF_EF),

  corporateVehicleList: createReducer(
    "GET_CORPORATE_VEHICLE_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  corporateVehicleAdd: createReducer(
    "ADD_CORPORATE_VEHICLE",
    DEFAULT_STATE_FF_EF,
  ),
  corporateVehicleListDelete: createReducer(
    "CORPORATE_VEHICLE_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  corporateVehicleById: createReducer(
    "CORPORATE_VEHICLE_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  vehicleBrandsDD: createReducer("GET_VEHICLEBRANDSDD", DEFAULT_STATE_FF_EF),
  vehicleModelsDD: createReducer("GET_VEHICLEMODELSDD", DEFAULT_STATE_FF_EF),
  vehicleYearsDD: createReducer("GET_VEHICLEYEARSDD", DEFAULT_STATE_FF_EF),
  vehicleColorsDD: createReducer("GET_VEHICLECOLORSDD", DEFAULT_STATE_FF_EF),

  getBrandAndModel: createReducer("BRAND_AND_MODEL", DEFAULT_STATE_FF_EF),
  getModel: createReducer("MODEL", DEFAULT_STATE_FF_EF),
  getInAirport: createReducer("ISAIRPORT", DEFAULT_STATE_FF_EF),
  getDriverTrackingDetail: createReducer(
    "DRIVER_TRACKING",
    DEFAULT_STATE_FF_EF,
  ),
  driverTrackingDetail: createReducer(
    "DRIVER_TRACKING_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  driverTrackingDetailSpecific: createReducer(
    "DRIVER_TRACKING_DETAILS_SPECIFIC",
    DEFAULT_STATE_FF_EF,
  ),
  driverTrackingDetailB2b: createReducer(
    "DRIVER_TRACKING_DETAILS_B2B",
    DEFAULT_STATE_FF_EF,
  ),
  driverTrackingDirection: createReducer(
    "DRIVER_TRACKING_DIRECTION",
    DEFAULT_STATE_FF_EF,
  ),

  driverDetails: createReducer("GET_DRIVER_DETAILS", DEFAULT_STATE_FF_EF),
  driverDetailsDelete: createReducer(
    "DRIVER_DETAILS_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  driverDetailsAdd: createReducer("DRIVER_DETAILS_ADD", DEFAULT_STATE_FF_EF),
  driverDetailsById: createReducer("DRIVER_DETAILS_BY_ID", DEFAULT_STATE_FF_EF),
  listBrandAndModel: createReducer("LIST_BRAND_AND_MODEL", DEFAULT_STATE_FF_EF),
  listModel: createReducer("LIST_MODEL", DEFAULT_STATE_FF_EF),

  auctoBidConfig: createReducer("GET_AUCTO_BID_CONFIG", DEFAULT_STATE_FF_EF),
  auctoBidConfigAdd: createReducer("AUCTO_BID_CONFIG_ADD", DEFAULT_STATE_FF_EF),
  auctoBidConfigDelete: createReducer(
    "AUCTO_BID_CONFIG_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  stateTaxDD: createReducer("GET_STATE_TAX", DEFAULT_STATE_FF_EF),
  fixedFareDD: createReducer("GET_FIXED_FARE_DD", DEFAULT_STATE_FF_EF),
  routeBasedFareDD: createReducer("GET_ROUTE_BASED_FARE", DEFAULT_STATE_FF_EF),
  operatorCurrentTab: createStaticReducer("OPERATOR_CURRENT_TAB", {
    operatorCurrentTab: "Personal",
  }),
  getOperatorAutoBidFare: createReducer(
    "OPERATING_AUTO_BID_FARE",
    DEFAULT_STATE_FF_EF,
  ),

  getFareEstimates: createReducer("FARE_ESTIMATES", DEFAULT_STATE_FF_EF),

  getB2cBookmarkList: createReducer(
    "GET_B2C_BOOKMARK_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  bookmarkNew: createReducer("BOOKMARK_NEW", DEFAULT_STATE_FF_EF),

  getSelectedCab: createReducer("SELECTED_CAB", DEFAULT_STATE_FF_EF),
  confirmSelectedCab: createReducer(
    "CONFIRM_SELECTED_CAB",
    DEFAULT_STATE_FF_EF,
  ),
  updateCommission: createReducer("UPDATE_COMMISSION", DEFAULT_STATE_FF_EF),
  getTaxidaCommission: createReducer("GET_COMMISSION", DEFAULT_STATE_FF_EF),
  states: createReducer("STATES", DEFAULT_STATE_FF_EF),

  operatorDiscounts: createReducer(
    "GET_OPERATOR_DISCOUNT",
    DEFAULT_STATE_FF_EF,
  ),
  operatorDiscountAdd: createReducer(
    "ADD_OPERATOR_DISCOUNT",
    DEFAULT_STATE_FF_EF,
  ),
  operatorDiscountById: createReducer(
    "OPERATOR_DISCOUNT_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  operatorDiscountDelete: createReducer(
    "OPERATOR_DISCOUNT_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  settingsConfig: createReducer("GET_SETTINGS_CONFIG", DEFAULT_STATE_FF_EF),
  siteSettingUpdate: createReducer("SITE_SETTINGS_UPDATE", DEFAULT_STATE_FF_EF),

  savaariConfig: createReducer("GET_SAVAARI_CONFIG", DEFAULT_STATE_FF_EF),
  savaariCreateBookingUpdate: createReducer(
    "SAVAARI_CREATE_BOOKING_UPDATE",
    DEFAULT_STATE_FF_EF,
  ),
  savaariManageBookingUpdate: createReducer(
    "SAVAARI_MANAGE_BOOKING_UPDATE",
    DEFAULT_STATE_FF_EF,
  ),

  killSwitchConfig: createReducer("GET_KILL_SWITCH_CONFIG", DEFAULT_STATE_FF_EF),
  killSwitchUpdate: createReducer("KILL_SWITCH_UPDATE", DEFAULT_STATE_FF_EF),
  getPromoFare: createReducer("GET_PROMOCODEFARE", DEFAULT_STATE_FF_EF),

  b2bBookingsAdd: createReducer("B2B_BOOKINGS_ADD", DEFAULT_STATE_FF_EF),
  b2bBookingsById: createReducer("B2B_BOOKINGS_BY_ID", DEFAULT_STATE_FF_EF),
  getBusinessUsers: createReducer("BUSINESS_USER_GET", DEFAULT_STATE_FF_EF),
  getAudit: createReducer("AUDIT_GET", DEFAULT_STATE_FF_EF),

  queueList: createReducer("GET_QUEUE_LIST", DEFAULT_STATE_FF_EF),
  assignedOperatorList: createReducer(
    "GET_ASSIGNED_OPERATOR_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  onTripList: createReducer("GET_ON_TRIP_LIST", DEFAULT_STATE_FF_EF),
  closedTripList: createReducer("GET_CLOSED_TRIP_LIST", DEFAULT_STATE_FF_EF),
  enquiryTripList: createReducer("GET_ENQUIRY_TRIP_LIST", DEFAULT_STATE_FF_EF),
  enquiryTripListFilters: createStaticReducer("ENQUIRY_TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),

  etsQueueList: createReducer("GET_ETS_QUEUE_LIST", DEFAULT_STATE_FF_EF),
  etsOnTripList: createReducer("GET_ETS_ON_TRIP_LIST", DEFAULT_STATE_FF_EF),
  etsClosedTripList: createReducer(
    "GET_ETS_CLOSED_TRIP_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  tmcQueueList: createReducer("GET_TMC_QUEUE_LIST", DEFAULT_STATE_FF_EF),
  tmcOnTripList: createReducer("GET_TMC_ON_TRIP_LIST", DEFAULT_STATE_FF_EF),
  tmcClosedTripList: createReducer(
    "GET_TMC_CLOSED_TRIP_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  queueListFilters: createStaticReducer("QUEUE_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  assignedOperatorListFilters: createStaticReducer(
    "ASSIGNED_OPERATOR_LIST_FILTERS",
    {
      fromDate: moment().format("DD-MM-YYYY"),
      toDate: "",
    },
  ),
  onTripListFilters: createStaticReducer("ON_TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  closedTripListFilters: createStaticReducer("CLOSED_TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  assignB2BOperator: createReducer(
    "GET_ASSIGN_B2B_OPERATOR",
    DEFAULT_STATE_FF_EF,
  ),
  assignB2BDriver: createReducer("GET_ASSIGN_B2B_DRIVER", DEFAULT_STATE_FF_EF),
  assignETSDriver: createReducer("GET_ASSIGN_ETS_DRIVER", DEFAULT_STATE_FF_EF),
  getLocationHistory: createReducer(
    "GET_LOCATION_HISTORY",
    DEFAULT_STATE_FF_EF,
  ),
  updatePickupLocation: createReducer(
    "UPDATE_PICKUP_LOCATION",
    DEFAULT_STATE_FF_EF,
  ),
  b2bBookingStatus: createReducer(
    "GET_B2B_BOOKING_STATUS",
    DEFAULT_STATE_FF_EF,
  ),

  enquiryBookingStatus: createReducer(
    "GET_ENQUIRY_BOOKING_STATUS",
    DEFAULT_STATE_FF_EF,
  ),

  corporate: createReducer("GET_CORPORATE", DEFAULT_STATE_FF_EF),
  corporateAdd: createReducer("CORPORATE_ADD", DEFAULT_STATE_FF_EF),
  corporateById: createReducer("CORPORATE_BY_ID", DEFAULT_STATE_FF_EF),

  tmc: createReducer("GET_TMC", DEFAULT_STATE_FF_EF),
  tmcAdd: createReducer("TMC_ADD", DEFAULT_STATE_FF_EF),
  tmcById: createReducer("TMC_BY_ID", DEFAULT_STATE_FF_EF),

  aggregator: createReducer("GET_AGGREGATOR", DEFAULT_STATE_FF_EF),
  aggregatorAdd: createReducer("AGGREGATOR_ADD", DEFAULT_STATE_FF_EF),
  aggregatorById: createReducer("AGGREGATOR_BY_ID", DEFAULT_STATE_FF_EF),

  supplier: createReducer("GET_SUPPLIER", DEFAULT_STATE_FF_EF),
  supplierAdd: createReducer("SUPPLIER_ADD", DEFAULT_STATE_FF_EF),
  supplierById: createReducer("SUPPLIER_BY_ID", DEFAULT_STATE_FF_EF),
  supplierAvailableAreas: createReducer("GET_AVAILABLE_AREAS", DEFAULT_STATE_FF_EF),
  supplierAssignedAreas: createReducer("GET_ASSIGNED_AREAS", DEFAULT_STATE_FF_EF),
  supplierAreaMutation: createReducer("MUTATE_AREA_RELATION", DEFAULT_STATE_FF_EF),
  availableOperators: createReducer("GET_AVAILABLE_OPERATORS", DEFAULT_STATE_FF_EF),
addSupplier: createReducer("ADD_SUPPLIER", DEFAULT_STATE_FF_EF),
deleteSupplier: createReducer("DELETE_SUPPLIER", DEFAULT_STATE_FF_EF),
  portalSuppliersList: createReducer(
    "GET_PORTAL_SUPPLIERS_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  portalSupplierAction: createReducer(
    "PORTAL_SUPPLIER_ACTION",
    DEFAULT_STATE_FF_EF,
  ),
  portalSupplierConfigs: createReducer(
    "PORTAL_SUPPLIER_CONFIGS",
    DEFAULT_STATE_FF_EF,
  ),
  portalSupplierEndpoints: createReducer(
    "PORTAL_SUPPLIER_ENDPOINTS",
    DEFAULT_STATE_FF_EF,
  ),
  portalSupplierOutboundAuth: createReducer(
    "PORTAL_SUPPLIER_OUTBOUND_AUTH",
    DEFAULT_STATE_FF_EF,
  ),

  demandActivity: createReducer("DEMAND_ACTIVITY", DEFAULT_STATE_FF_EF),
  demandActivityDetail: createReducer(
    "DEMAND_ACTIVITY_DETAIL",
    DEFAULT_STATE_FF_EF,
  ),
  demandBookings: createReducer("DEMAND_BOOKINGS", DEFAULT_STATE_FF_EF),
  supplyActivity: createReducer("SUPPLY_ACTIVITY", DEFAULT_STATE_FF_EF),
  supplyActivityDetail: createReducer(
    "SUPPLY_ACTIVITY_DETAIL",
    DEFAULT_STATE_FF_EF,
  ),
  supplyBlocks: createReducer("SUPPLY_BLOCKS", DEFAULT_STATE_FF_EF),
  supplyConfirms: createReducer("SUPPLY_CONFIRMS", DEFAULT_STATE_FF_EF),
  partnerAudit: createReducer("PARTNER_AUDIT", DEFAULT_STATE_FF_EF),
  partnerAuditDetail: createReducer("PARTNER_AUDIT_DETAIL", DEFAULT_STATE_FF_EF),
  partnerAuditLifecycle: createReducer("PARTNER_AUDIT_LIFECYCLE", DEFAULT_STATE_FF_EF),
  partnerAuditPartners: createReducer("PARTNER_AUDIT_PARTNERS", DEFAULT_STATE_FF_EF),
  searchList: createReducer("SEARCH_LIST", DEFAULT_STATE_FF_EF),
  searchDetail: createReducer("SEARCH_DETAIL", DEFAULT_STATE_FF_EF),
  portalSupplierAreas: createReducer("SUPPLIER_OPERATING_AREAS", DEFAULT_STATE_FF_EF),
  portalSupplierAreaToggle: createReducer("SUPPLIER_OPERATING_AREA_TOGGLE", DEFAULT_STATE_FF_EF),
  portalSupplierSideActivation: createReducer("SUPPLIER_SIDE_ACTIVATION", DEFAULT_STATE_FF_EF),
  portalSupplierSideActivationToggle: createReducer("SUPPLIER_SIDE_ACTIVATION_TOGGLE", DEFAULT_STATE_FF_EF),
  portalSupplierAuditHistory: createReducer("SUPPLIER_AUDIT_HISTORY", DEFAULT_STATE_FF_EF),

  partners: createReducer("GET_PARTNERS", DEFAULT_STATE_FF_EF),
  partnerById: createReducer("PARTNER_BY_ID", DEFAULT_STATE_FF_EF),
  partnerMutation: createReducer("PARTNER_MUTATION", DEFAULT_STATE_FF_EF),

  branchManager: createReducer("GET_BRANCH_MANAGER", DEFAULT_STATE_FF_EF),
  branchManagerAdd: createReducer("BRANCH_MANAGER_ADD", DEFAULT_STATE_FF_EF),
  branchManagerById: createReducer("BRANCH_MANAGER_BY_ID", DEFAULT_STATE_FF_EF),

  businessPartners: createReducer("GET_BUSINESS_PARTNER", DEFAULT_STATE_FF_EF),
  businessPartnerAdd: createReducer(
    "ADD_BUSINESS_PARTNER",
    DEFAULT_STATE_FF_EF,
  ),
  businessPartnerById: createReducer(
    "BUSINESS_PARTNER_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  businessPartnerDelete: createReducer(
    "BUSINESS_PARTNER_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  corporateDD: createReducer("GET_CORPORATEDD", DEFAULT_STATE_FF_EF),
  aggregatorDD: createReducer("GET_AGGREGATORDD", DEFAULT_STATE_FF_EF),
  aggregatorRegionDD: createReducer(
    "GET_AGGREGATOR_REGION_DD",
    DEFAULT_STATE_FF_EF,
  ),

  googleCustomPlaces: createReducer(
    "GOOGLE_CUSTOM_PLACES",
    DEFAULT_STATE_FF_EF,
  ),

  stateDD: createReducer("GET_STATEDD", DEFAULT_STATE_FF_EF),
  districtDD: createReducer("GET_DISTRICTDD", DEFAULT_STATE_FF_EF),

  tripSheetData: createReducer("GET_TRIP_SHEET", DEFAULT_STATE_FF_EF),

  etsTripSheetData: createReducer("GET_ETS_TRIP_SHEET", DEFAULT_STATE_FF_EF),
  tmcTripSheetData: createReducer("GET_TMC_TRIP_SHEET", DEFAULT_STATE_FF_EF),

  getVehicleDetails: createReducer("GET_VEHICLE_DETAILS", DEFAULT_STATE_FF_EF),

  getDriverData: createReducer("GET_DRIVER_BY_PHONE", DEFAULT_STATE_FF_EF),
  getVehicleData: createReducer("GET_VEHICLE_BY_REGNO", DEFAULT_STATE_FF_EF),

  fetchB2BOperator: createReducer("FETCH_B2B_OPERATOR", DEFAULT_STATE_FF_EF),
  fetchB2COperator: createReducer("FETCH_B2C_OPERATOR", DEFAULT_STATE_FF_EF),

  employeeList: createReducer("GET_EMPLOYEE_LIST", DEFAULT_STATE_FF_EF),
  employeeAdd: createReducer("ADD_EMPLOYEE", DEFAULT_STATE_FF_EF),
  employeeById: createReducer("EMPLOYEE_BY_ID", DEFAULT_STATE_FF_EF),
  specificBranchManager: createReducer(
    "GET_SPECIFIC_BRANCH_MANAGER",
    DEFAULT_STATE_FF_EF,
  ),

  geofenceVehicle: createReducer("GET_GEOFENCE_VEHICLE", DEFAULT_STATE_FF_EF),
  geofenceVehiclePricing: createReducer(
    "GET_GEOFENCE_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  dynamicVehiclePricing: createReducer(
    "GET_DYNAMIC_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  geofenceVehicleAdd: createReducer(
    "ADD_GEOFENCE_VEHICLE",
    DEFAULT_STATE_FF_EF,
  ),
  geofenceVehicleById: createReducer(
    "GEOFENCE_VEHICLE_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  geofenceVehicleById: createReducer(
    "GEOFENCE_VEHICLE_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  geofencePricing: createReducer("GET_GEOFENCE_PRICING", DEFAULT_STATE_FF_EF),
  geofencePricingAdd: createReducer(
    "ADD_GEOFENCE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  geofencePricingById: createReducer(
    "GEOFENCE_PRICING_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  dynamicPricing: createReducer("GET_DYNAMIC_PRICING", DEFAULT_STATE_FF_EF),
  dynamicPricingAdd: createReducer("ADD_DYNAMIC_PRICING", DEFAULT_STATE_FF_EF),
  dynamicPricingById: createReducer(
    "DYNAMIC_PRICING_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  additionalPricing: createReducer(
    "GET_ADDITIONAL_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  additionalPricingAdd: createReducer(
    "ADD_ADDITIONAL_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  additionalPricingById: createReducer(
    "ADDITIONAL_PRICING_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  pricingListDelete: createReducer("PRICING_LIST_DELETE", DEFAULT_STATE_FF_EF),
  additionalPricingListDelete: createReducer(
    "ADDITIONAL_PRICING_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  dynamicListDelete: createReducer("DYNAMIC_LIST_DELETE", DEFAULT_STATE_FF_EF),
  pricingVehicleListDelete: createReducer(
    "PRICING_VEHICLE_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  etsDriverInfo: createReducer("GET_ETS_DRIVER_INFO", DEFAULT_STATE_FF_EF),
  etsVehicleInfo: createReducer("GET_ETS_VEHICLE_INFO", DEFAULT_STATE_FF_EF),
  etsAdmins: createReducer("GET_ETS_ADMINS", DEFAULT_STATE_FF_EF),
  etsBookingAdd: createReducer("ETS_BOOKING_CREATION", DEFAULT_STATE_FF_EF),
  bookingAnalytics: createReducer("GET_ANALYTICS", DEFAULT_STATE_FF_EF),
  aggregatorAnalytics: createReducer(
    "GET_AGGREGATOR_ANALYTICS",
    DEFAULT_STATE_FF_EF,
  ),

  broadcastAssign: createReducer("BROADCAST_ASSIGN", DEFAULT_STATE_FF_EF),
  broadcastReAssign: createReducer("BROADCAST_RE_ASSIGN", DEFAULT_STATE_FF_EF),
  revokeAssign: createReducer("REVOKE_ASSIGN", DEFAULT_STATE_FF_EF),
  wavescabAssign: createReducer("WAVESCAB_ASSIGN", DEFAULT_STATE_FF_EF),
  refexSearch: createReducer("REFEX_SEARCH", DEFAULT_STATE_FF_EF),
  refexBlock: createReducer("REFEX_BLOCK", DEFAULT_STATE_FF_EF),
  refexConfirm: createReducer("REFEX_CONFIRM", DEFAULT_STATE_FF_EF),
  portalSupplierSearch: createReducer("PORTAL_SUPPLIER_SEARCH", DEFAULT_STATE_FF_EF),
  portalSupplierBlock: createReducer("PORTAL_SUPPLIER_BLOCK", DEFAULT_STATE_FF_EF),
  portalSupplierConfirm: createReducer("PORTAL_SUPPLIER_CONFIRM", DEFAULT_STATE_FF_EF),
  confirmDriver: createReducer("CONFIRM_DRIVER", DEFAULT_STATE_FF_EF),
  broadcastDriverList: createReducer(
    "GET_BROADCAST_DRIVER",
    DEFAULT_STATE_FF_EF,
  ),
  cancelB2cBooking: createReducer("CANCEL_B2C_BOOKING", DEFAULT_STATE_FF_EF),
  cancelB2cFare: createReducer("GET_CANCEL_B2C_FARE", DEFAULT_STATE_FF_EF),
  whatsappAssign: createReducer("GET_WHATSAPP_ASSIGN", DEFAULT_STATE_FF_EF),

  cancelAggregatorBooking: createReducer(
    "CANCEL_AGGREGATOR_BOOKING",
    DEFAULT_STATE_FF_EF,
  ),
  ondc: createReducer("GET_ONDC", DEFAULT_STATE_FF_EF),
  ondcAdd: createReducer("ONDC_ADD", DEFAULT_STATE_FF_EF),
  ondcById: createReducer("ONDC_BY_ID", DEFAULT_STATE_FF_EF),

  providerVehicle: createReducer("GET_PROVIDER_VEHICLE", DEFAULT_STATE_FF_EF),
  providerVehicleAdd: createReducer(
    "ADD_PROVIDER_VEHICLE",
    DEFAULT_STATE_FF_EF,
  ),

  ondcGeofence: createReducer("ONDC_GEOFENCE", DEFAULT_STATE_FF_EF),
  ondcGeofenceDetail: createReducer(
    "ONDC_GEOFENCE_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  ondcGeofenceAdd: createReducer("ONDC_GEOFENCE_ADD", DEFAULT_STATE_FF_EF),
  ondcGeofenceById: createReducer("ONDC_GEOFENCE_BY_ID", DEFAULT_STATE_FF_EF),

  ondcVehiclePricing: createReducer(
    "GET_ONDC_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDynamicVehiclePricing: createReducer(
    "GET_ONDC_DYNAMIC_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDynamicHotspotVehiclePricing: createReducer(
    "GET_ONDC_DYNAMIC_HOTSPOT_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcGeofenceVehiclePricing: createReducer(
    "GET_ONDC_GEOFENCE_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),

  ondcGeofencePricing: createReducer(
    "GET_ONDC_GEOFENCE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcGeofencePricingAdd: createReducer(
    "ADD_ONDC_GEOFENCE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),

  ondcDynamicPricing: createReducer(
    "GET_ONDC_DYNAMIC_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDynamicPricingAdd: createReducer(
    "ADD_ONDC_DYNAMIC_PRICING",
    DEFAULT_STATE_FF_EF,
  ),

  ondcOtherPricing: createReducer(
    "GET_ONDC_OTHER_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcOtherPricingAdd: createReducer(
    "ONDC_OTHER_PRICING_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDynamicHotspotPricing: createReducer(
    "GET_ONDC_DYNAMIC_HOTSPOT_PRICING",
    DEFAULT_STATE_FF_EF,
  ),

  ondcAdditionalPricing: createReducer(
    "GET_ONDC_ADDITIONAL_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDowntimePricing: createReducer(
    "GET_ONDC_DOWNTIME_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDowntimePricingAdd: createReducer(
    "ADD_ONDC_DOWNTIME_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDowntimeVehiclePricing: createReducer(
    "GET_ONDC_DOWNTIME_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDowntimeHotspotPricing: createReducer(
    "GET_ONDC_DOWNTIME_HOTSPOT_PRICING",
    DEFAULT_STATE_FF_EF,
  ),

  rentalPricing: createReducer("GET_RENTAL_PRICING", DEFAULT_STATE_FF_EF),
  rentalPricingAdd: createReducer("ADD_RENTAL_PRICING", DEFAULT_STATE_FF_EF),
  rentalHotspotPricing: createReducer(
    "GET_RENTAL_HOTSPOT_PRICING",
    DEFAULT_STATE_FF_EF,
  ),

  ondcVehicleListDelete: createReducer(
    "ONDC_VEHICLE_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  ondcPricingListDelete: createReducer(
    "ONDC_PRICING_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDynamicListDelete: createReducer(
    "ONDC_DYNAMIC_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  ondcAdditionalPricingListDelete: createReducer(
    "ONDC_ADDITIONAL_PRICING_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  rentalListDelete: createReducer("RENTAL_LIST_DELETE", DEFAULT_STATE_FF_EF),
  downtimeListDelete: createReducer(
    "DOWNTIME_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  ondcHotspotPricingListDelete: createReducer(
    "ONDC_HOTSPOT_PRICING_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  ondcHotspotDynamicListDelete: createReducer(
    "ONDC_HOTSPOT_DYNAMIC_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  ondcAdditionalHotspotPricingListDelete: createReducer(
    "ONDC_ADDITIONAL_HOTSPOT_PRICING_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  rentalHotspotListDelete: createReducer(
    "RENTAL_HOTSPOT_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  downtimeHotspotListDelete: createReducer(
    "DOWNTIME_HOTSPOT_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  ondcRentalVehiclePricing: createReducer(
    "GET_ONDC_RENTAL_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  ondcRentalVehicleHotspotPricing: createReducer(
    "GET_ONDC_RENTAL_VEHICLE_HOTSPOT_PRICING",
    DEFAULT_STATE_FF_EF,
  ),

  sellerEnquiry: createReducer("GET_SELLER_ENQUIRY", DEFAULT_STATE_FF_EF),
  sellerEnquiryDetail: createReducer(
    "GET_SELLER_ENQUIRY_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  buyerEnquiry: createReducer("GET_BUYER_ENQUIRY", DEFAULT_STATE_FF_EF),
  buyerEnquiryDetail: createReducer(
    "GET_BUYER_ENQUIRY_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  assignOndcDriver: createReducer(
    "GET_ASSIGN_ONDC_DRIVER",
    DEFAULT_STATE_FF_EF,
  ),
  ondcDriverAssign: createReducer("ONDC_DRIVER_ASSIGN", DEFAULT_STATE_FF_EF),
  ondcCancelTrip: createReducer("ONDC_CANCEL_TRIP", DEFAULT_STATE_FF_EF),
  ondcCompleteTrip: createReducer("ONDC_COMPLETE_TRIP", DEFAULT_STATE_FF_EF),

  vendorList: createReducer("GET_VENDOR_LIST", DEFAULT_STATE_FF_EF),
  vendorTypes: createReducer("GET_VENDOR_TYPES", DEFAULT_STATE_FF_EF),
  bankList: createReducer("GET_BANK_LIST", DEFAULT_STATE_FF_EF),
  vendorAdd: createReducer("VENDOR_ADD", DEFAULT_STATE_FF_EF),
  vendorById: createReducer("VENDOR_BY_ID", DEFAULT_STATE_FF_EF),
  vendorEdit: createReducer("VENDOR_EDIT", DEFAULT_STATE_FF_EF),
  vendorOperatingAreaList: createReducer(
    "VENDOR_OPERATING_AREA_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  vendorOperatingAreaAdd: createReducer(
    "ADD_VENDOR_OPERATING_AREA",
    DEFAULT_STATE_FF_EF,
  ),
  vendorRegionDelete: createReducer(
    "VENDOR_REGION_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  otaGeofenceAddHotspot: createReducer(
    "OTA_GEOFENCE_HOTSPOT_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  otaGeofenceHotspotDetail: createReducer(
    "OTA_GEOFENCE_HOTSPOT_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  additionalAirportPricing: createReducer(
    "GET_ADDITIONAL_AIRPORT_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  additionalAirportPricingAdd: createReducer(
    "ADDITIONAL_AIRPORT_PRICING_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  additionalAirportPricingById: createReducer(
    "ADDITIONAL_AIRPORT_PRICING_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  additionalAirportPricingDelete: createReducer(
    "ADDITIONAL_AIRPORT_PRICING_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  airportStateList: createReducer(
    "GET_AIRPORT_STATE_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  fixedPricing: createReducer("GET_FIXED_PRICING", DEFAULT_STATE_FF_EF),
  fixedPricingAdd: createReducer("FIXED_PRICING_ADD", DEFAULT_STATE_FF_EF),
  fixedPricingById: createReducer("FIXED_PRICING_BY_ID", DEFAULT_STATE_FF_EF),
  fixedPricingDelete: createReducer(
    "FIXED_PRICING_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  hillStateList: createReducer("GET_HILL_STATE_LIST", DEFAULT_STATE_FF_EF),
  hillPricingAdd: createReducer("HILL_PRICING_ADD", DEFAULT_STATE_FF_EF),
  hillPricingById: createReducer("HILL_PRICING_BY_ID", DEFAULT_STATE_FF_EF),

  fixedVehiclePricing: createReducer(
    "GET_FIXED_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  additionalVehiclePricing: createReducer(
    "GET_ADDITIONAL_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  regionHotspot: createReducer("GET_REGION_HOTSPOT", DEFAULT_STATE_FF_EF),
  getDashTable: createReducer("GET_DASH_TABLE", DEFAULT_STATE_FF_EF),
  getDashB2cTable: createReducer("GET_DASH_B2C_TABLE", DEFAULT_STATE_FF_EF),
  getMmtTripTable: createReducer("GET_MMT_TRIP_TABLE", DEFAULT_STATE_FF_EF),
  getTaxidaProcuredBookings: createReducer(
    "GET_TAXIDA_PROCURED_BOOKINGS",
    DEFAULT_STATE_FF_EF,
  ),
  procuredSnapshot: createReducer(
    "GET_PROCURED_SNAPSHOT",
    DEFAULT_STATE_FF_EF,
  ),
  pnlMargins: createReducer("GET_PNL_MARGINS", DEFAULT_STATE_FF_EF),
  pnlDaywise: createReducer("GET_PNL_DAYWISE", DEFAULT_STATE_FF_EF),
  operatorBcResponse: createReducer(
    "GET_OPERATOR_BC_RESPONSE",
    DEFAULT_STATE_FF_EF,
  ),
  operatorBcValue: createReducer("GET_OPERATOR_BC_VALUE", DEFAULT_STATE_FF_EF),

  customerEnquiry: createReducer("CUSTOMER_ENQUIRY_ADD", DEFAULT_STATE_FF_EF),

  getNewEnqDetail: createReducer("GET_NEW_ENQUIRY_DETAIL", DEFAULT_STATE_FF_EF),
  savaariAuditsList: createReducer("GET_SAVAARI_AUDITS_LIST", DEFAULT_STATE_FF_EF),
  savaariAnalytics: createReducer("GET_SAVAARI_ANALYTICS", DEFAULT_STATE_FF_EF),
  savaariMisOperators: createReducer(
    "GET_SAVAARI_MIS_OPERATORS",
    DEFAULT_STATE_FF_EF,
  ),
  savaariManualFaresList: createReducer(
    "GET_SAVAARI_MANUAL_FARES_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  submitManualFareResponse: createReducer(
    "SUBMIT_MANUAL_FARE",
    DEFAULT_STATE_FF_EF,
  ),
  acceptSavaariFareResponse: createReducer(
    "ACCEPT_SAVAARI_FARE",
    DEFAULT_STATE_FF_EF,
  ),
  savaariBookingDetail: createReducer("SAVAARI_BOOKING_DETAIL", DEFAULT_STATE_FF_EF),
  partnerAuditBooking: createReducer("PARTNER_AUDIT_BOOKING", DEFAULT_STATE_FF_EF),

  updateVehicleFare: createReducer("UPDATE_VEHICLE_FARE", DEFAULT_STATE_FF_EF),

  noServiceZone: createReducer("NO_SERVICE_ZONE", DEFAULT_STATE_FF_EF),
  noServiceZoneDetail: createReducer(
    "NO_SERVICE_ZONE_DETAILS",
    DEFAULT_STATE_FF_EF,
  ),
  noServiceZoneAdd: createReducer("NO_SERVICE_ZONE_ADD", DEFAULT_STATE_FF_EF),
  noServiceZoneById: createReducer(
    "NO_SERVICE_ZONE_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  noServiceZoneListDelete: createReducer(
    "NO_SERVICE_ZONE_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  hotRoute: createReducer("HOT_ROUTE", DEFAULT_STATE_FF_EF),

  hotRouteDetail: createReducer("HOT_ROUTE_DETAILS", DEFAULT_STATE_FF_EF),
  hotRouteAdd: createReducer("HOT_ROUTE_ADD", DEFAULT_STATE_FF_EF),
  hotRouteById: createReducer("HOT_ROUTE_BY_ID", DEFAULT_STATE_FF_EF),
  hotRouteListDelete: createReducer(
    "HOT_ROUTE_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),
  hotRouteLocalConfig: createReducer(
    "HOT_ROUTE_LOCAL_CONFIG",
    DEFAULT_STATE_FF_EF,
  ),
  hotRouteLocalConfigDD: createReducer(
    "HOT_ROUTE_LOCAL_CONFIG_DD",
    DEFAULT_STATE_FF_EF,
  ),
  hotRouteLocalConfigAdd: createReducer(
    "HOT_ROUTE_LOCAL_CONFIG_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  hotRouteVehiclePricing: createReducer(
    "GET_HOT_ROUTE_VEHICLE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  hotRoutePricings: createReducer("HOT_ROUTE_PRICINGS", DEFAULT_STATE_FF_EF),
  hotRoutePricingsAdd: createReducer(
    "HOT_ROUTE_PRICINGS_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  hotRoutePricingsDelete: createReducer(
    "HOT_ROUTE_PRICING_LIST_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  aggregatorNew: createReducer("GET_AGGREGATOR_LIST", DEFAULT_STATE_FF_EF),
  aggregatorNewAdd: createReducer("AGGREGATOR_NEW_ADD", DEFAULT_STATE_FF_EF),
  aggregatorNewById: createReducer("AGGREGATOR_NEW_BY_ID", DEFAULT_STATE_FF_EF),

  operatingAreaNew: createReducer("OPERATING_AREA_NEW", DEFAULT_STATE_FF_EF),
  operatingAreaNewAdd: createReducer(
    "OPERATING_AREA_NEW_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  operatingAreaNewDetail: createReducer(
    "OPERATING_AREA_NEW_DETAIL",
    DEFAULT_STATE_FF_EF,
  ),

  geofenceNew: createReducer("GEOFENCE_NEW", DEFAULT_STATE_FF_EF),
  geofenceNewAdd: createReducer("GEOFENCE_NEW_ADD", DEFAULT_STATE_FF_EF),

  routeMap: createReducer("ROUTE_MAP", DEFAULT_STATE_FF_EF),

  operatorNewList: createReducer("GET_OPERATOR_NEW_LIST", DEFAULT_STATE_FF_EF),
  operatorNewAdd: createReducer("OPERATOR_NEW_ADD", DEFAULT_STATE_FF_EF),
  operatorNewById: createReducer("OPERATOR_NEW_BY_ID", DEFAULT_STATE_FF_EF),
  subscriptionId: createReducer("SUBSCRIPTION_ID", DEFAULT_STATE_FF_EF),

  operatorAreaList: createReducer("OPERATOR_AREA_LIST", DEFAULT_STATE_FF_EF),
  operatorAreaAdd: createReducer("OPERATOR_AREA_ADD", DEFAULT_STATE_FF_EF),
  operatorAreaById: createReducer("OPERATOR_AREA_BY_ID", DEFAULT_STATE_FF_EF),

  aggregatorDetach: createReducer("AGGREGATOR_DETACH", DEFAULT_STATE_FF_EF),
  updateReceivables: createReducer("UPDATE_RECEIVABLES", DEFAULT_STATE_FF_EF),
  updatePayable: createReducer("UPDATE_PAYABLE", DEFAULT_STATE_FF_EF),

  vehicleBasePricingAdd: createReducer(
    "VEHICLE_BASE_PRICING_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  vehicleBasePricingList: createReducer(
    "VEHICLE_BASE_PRICING_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  vehicleBasePricingById: createReducer(
    "VEHICLE_BASE_PRICING_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),
  vehicleBasePricingDelete: createReducer(
    "VEHICLE_BASE_PRICING_DELETE",
    DEFAULT_STATE_FF_EF,
  ),

  vehicleExclusive: createReducer("GET_VEHICLE_EXCLUSIVE", DEFAULT_STATE_FF_EF),
  vehicleExclusiveFixedRoute: createReducer(
    "GET_VEHICLE_EXCLUSIVE_FIXED_ROUTE",
    DEFAULT_STATE_FF_EF,
  ),

  notificationConfig: createReducer(
    "NOTIFICATION_CONFIG_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  notificationConfigById: createReducer(
    "NOTIFICATION_CONFIG_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  notificationList: createReducer("GET_NOTIFICATION_LIST", DEFAULT_STATE_FF_EF),
  notificationListFilters: createStaticReducer("NOTIFICATION_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),

  distanceMatrix: createReducer("GET_DISTANCE_MATRIX", DEFAULT_STATE_FF_EF),
  placesDetail: createReducer("GET_PLACES_DETAIL", DEFAULT_STATE_FF_EF),
  autoPricingList: createReducer("GET_AUTO_PRICING_LIST", DEFAULT_STATE_FF_EF),
  configCheck: createReducer("CONFIG_CHECK", DEFAULT_STATE_FF_EF),

  inprogressTripList: createReducer(
    "GET_INPROGRESS_TRIP_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  completedTripList: createReducer(
    "GET_COMPLETED_TRIP_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  inprogressListFilters: createStaticReducer("INPROGRESS_TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),
  completedTripListFilters: createStaticReducer("COMPLETED_TRIP_LIST_FILTERS", {
    fromDate: moment().format("DD-MM-YYYY"),
    toDate: "",
  }),

  deviceIdAdd: createReducer("DEVICE_ID_ADD", DEFAULT_STATE_FF_EF),
  deviceListGet: createReducer("GET_ADMIN_DEVICE_INFO", DEFAULT_STATE_FF_EF),

  mobileListGet: createReducer("GET_MOBILE_DEVICE_LIST", DEFAULT_STATE_FF_EF),
  MobileIdAdd: createReducer("MOBILE_DEVICE_ID_ADD", DEFAULT_STATE_FF_EF),

  notificationAdd: createReducer(
    "NOTIFICATION_CONFIGURATION_ADD",
    DEFAULT_STATE_FF_EF,
  ),
  notificationGet: createReducer(
    "GET_NOTIFICATION_CONFIGURATION",
    DEFAULT_STATE_FF_EF,
  ),

  getOperatorList: createReducer("GET_OPERATOR_LIST", DEFAULT_STATE_FF_EF),
  getOperatingAreaList: createReducer(
    "GET_OPERATING_AREA_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  getTimeBasedHotspotList: createReducer(
    "GET_TIME_BASED_HOTSPOT_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  getTimeBasedHotrouteList: createReducer(
    "GET_TIME_BASED_HOTROUTE_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  addTimeBasedPricing: createReducer(
    "ADD_TIME_BASED_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  deleteTimeBasedPricing: createReducer(
    "DELETE_TIME_BASED_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  deleteTimeBasedRegion: createReducer(
    "DELETE_TIME_BASED_BY_REGION",
    DEFAULT_STATE_FF_EF,
  ),
  deleteTimeBasedReference: createReducer(
    "DELETE_TIME_BASED_BY_REFERENCE",
    DEFAULT_STATE_FF_EF,
  ),
  getcountReference: createReducer(
    "GET_COUNT_BY_REFERENCE",
    DEFAULT_STATE_FF_EF,
  ),

  getHotRouteFilterList: createReducer(
    "GET_HOT_ROUTE_LIST_BASED_ON_REGION",
    DEFAULT_STATE_FF_EF,
  ),
  getSlaAudit: createReducer("SLA_AUDIT_GET", DEFAULT_STATE_FF_EF),

  getTimeBasedHotspotCollapsed: createReducer(
    "GET_TIME_BASED_COLLAPSED_HOTSPOT_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  getTimeBasedHotrouteCollapsed: createReducer(
    "GET_TIME_BASED_COLLAPSED_HOTROUTE_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  deleteTimeBasedHotspotCollapsed: createReducer(
    "DELETE_TIME_BASED_COLLAPSED_HOTSPOT_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  getTimeBasedHotspotExpandable: createReducer(
    "GET_TIME_BASED_EXPANDABLE_HOTSPOT_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  getTimeBasedHotrouteExpandable: createReducer(
    "GET_TIME_BASED_EXPANDABLE_HOTROUTE_LIST",
    DEFAULT_STATE_FF_EF,
  ),
  bulkEditTimeBasedPricing: createReducer(
    "ADD_TIME_BASED_PRICING_BULKEDIT",
    DEFAULT_STATE_FF_EF,
  ),
  timeBasedAnalatics: createReducer(
    "GET_TIME_BASED_ANALYTICS",
    DEFAULT_STATE_FF_EF,
  ),

  addSurgePricing: createReducer(
    "ADD_GLOBAL_SURGE_PRICING",
    DEFAULT_STATE_FF_EF,
  ),
  getSurgePricingList: createReducer(
    "GET_GLOBAL_SURGE_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  savePriceEngineSurge: createReducer(
    "ADD_PRICE_ENGINE_SURGE",
    DEFAULT_STATE_FF_EF,
  ),

  getPriceEngineSurgeList: createReducer(
    "GET_PRICE_ENGINE_SURGE_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  deletePriceEngineSurge: createReducer(
    "DELETE_PRICE_ENGINE_SURGE",
    DEFAULT_STATE_FF_EF,
  ),

  updatePriceEngineSurge: createReducer(
    "UPDATE_PRICE_ENGINE_SURGE",
    DEFAULT_STATE_FF_EF,
  ),

  getPriceEngineSurgeById: createReducer(
    "GET_PRICE_ENGINE_SURGE_BY_ID",
    DEFAULT_STATE_FF_EF,
  ),

  deleteSurgePricing: createReducer("DELETE_GLOBAL_SURGE", DEFAULT_STATE_FF_EF),
  driverLocations: createReducer("GET_DRIVER_LOCATIONS", DEFAULT_STATE_FF_EF),
  aariMessagesList: createReducer("AARI_MESSAGES_LIST", DEFAULT_STATE_FF_EF),
  AariConversationDetail: createReducer(
    "AARI_CONVERSATION_DETAIL",
    DEFAULT_STATE_FF_EF,
  ),

  aggregatorSurgeAdd: createReducer(
    "AGGREGATOR_SURGE_ADD",
    DEFAULT_STATE_FF_EF,
  ),

  B2cNewEnquiryList: createReducer(
    "GET_B2C_NEW_ENQUIRY_TRIP_LIST",
    DEFAULT_STATE_FF_EF,
  ),

  NewEnqDetail: createReducer("GET_NEW_ENQUIRY_DETAIL", DEFAULT_STATE_FF_EF),

  AgentEnquiryList: createReducer(
    "GET_AGENT_ENQUIRY_TRIP_LIST",
    DEFAULT_STATE_FF_EF,
  ),
});

export default rootReducer;
